import Vue from 'vue';
import Router, { Route } from 'vue-router';

import NotFound from '@/view/not-found.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: () => import(/* webpackChunkName: "home" */ '@/view/home.vue') },
    { path: '/404', component: NotFound },
    { path: '*', redirect: '/404' }
  ]
});

export default router;
